module.exports = __webpack_public_path__ + "static/media/flowers-bombing-home-PC.d0b62647.jpg";